import React, {useCallback, useState} from 'react';
import {useParams} from 'react-router-dom';
import AppHeader from '../components/AppHeader.js';
import MyBonusList from '../components/MyBonusList.js';

export default function MyBonus({usrInfo, timerCnt}) {
	const [loading, setLoading] = useState(false);

	// /mybonus/:targetUsrId – sysadmin si stránku otevře pro vybraného uživatele.
	const {targetUsrId} = useParams();

	const handleLoadingChange = useCallback((isLoading) => {
		setLoading(isLoading);
	}, []);

	return (
		<>
			<div className="page_main">
				<AppHeader usrInfo={usrInfo} timerCnt={timerCnt} loading={loading} />

				<div className={`page mybonus-page${usrInfo.sysAdmin === 1 || usrInfo.manager === 1 || usrInfo.instructor === 1 ? ' more' : ''}`}>
					<MyBonusList usrInfo={usrInfo} targetUsrId={targetUsrId} onLoadingChange={handleLoadingChange} />
				</div>
			</div>
		</>
	);
}
